if (!customElements.get('rr-d96-personalization')) {
  customElements.define('rr-d96-personalization', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.form = this.closest('form');
      this.root = this.closest('product-info') || this.form;
      this.input = this.querySelector('[data-d96-text]');
      this.svg = this.querySelector('[data-d96-svg]');
      this.text = this.querySelector('[data-d96-preview-text]');
      this.dialog = this.querySelector('[data-d96-dialog]');
      this.data = JSON.parse(this.querySelector('[data-d96-shapes]').textContent);
      this.font = JSON.parse(this.querySelector('[data-d96-font]').textContent);
      this.variants = JSON.parse(this.querySelector('[data-d96-variants]').textContent);
      this.submit = this.form.querySelector('[name="add"][type="submit"]');
      this.querySelector('[data-d96-open]').addEventListener('click', () => this.open());
      this.querySelector('[data-d96-close]').addEventListener('click', () => this.close());
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.close(); });
      this.dialog.addEventListener('keydown', event => {
        if (event.key === 'Escape') this.close();
        if (event.key !== 'Tab') return;
        const focusable = [...this.dialog.querySelectorAll('button:not([disabled]), input:not([type="hidden"])')].filter(el => el.getClientRects().length);
        const first = focusable[0], last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      });
      this.querySelectorAll('[data-d96-size]').forEach(button => button.addEventListener('click', () => { this.dataset.size = button.dataset.d96Size; this.selectVariant(); }));
      this.querySelectorAll('[data-d96-finish]').forEach(button => button.addEventListener('click', () => { this.dataset.finish = button.dataset.d96Finish; this.selectVariant(); }));
      this.querySelectorAll('input[name="properties[Animal]"]').forEach(radio => radio.addEventListener('change', () => this.update()));
      this.input.addEventListener('input', () => this.update());
      this.input.addEventListener('blur', () => { this.input.value = this.input.value.trim(); this.update(); });
      this.querySelector('[data-d96-add]').addEventListener('click', () => { this.update(); if (this.dataset.valid === 'true') { this.close(); this.form.requestSubmit(this.submit); } });
      this.form.addEventListener('submit', event => {
        this.input.value = this.input.value.trim(); this.update();
        if (this.dataset.valid !== 'true') { event.preventDefault(); event.stopImmediatePropagation(); this.open(); this.form.reportValidity(); }
      }, true);
      document.fonts.load('20px "RR D96 Copperplate"').then(() => this.update());
      this.resize = new ResizeObserver(() => this.update()); this.resize.observe(this);
      this.selectVariant();
    }
    disconnectedCallback() { this.resize?.disconnect(); }
    open() { this.lastFocus = document.activeElement; this.dialog.hidden = false; document.documentElement.classList.add('rr-personalization-open'); requestAnimationFrame(() => { this.update(); this.input.focus(); }); }
    close() { this.dialog.hidden = true; document.documentElement.classList.remove('rr-personalization-open'); this.lastFocus?.focus(); }
    selectVariant() {
      const variant = this.variants.find(item => item.size === this.dataset.size && item.finish === this.dataset.finish);
      this.variant = variant;
      const pricedVariant = variant || this.variants.find(item => item.size === this.dataset.size);
      if (pricedVariant) this.querySelector('[data-d96-price]').textContent = pricedVariant.price;
      this.dataset.selectedVariantId = variant ? String(variant.id) : '';
      if (variant) {
        this.form.querySelector('input[name="id"]').value = String(variant.id);
        this.root.querySelectorAll('variant-selects input[type="radio"]').forEach(radio => { radio.checked = radio.value === variant.size || radio.value === variant.finish; });
        this.querySelector('[data-d96-price]').textContent = variant.price;
        const price = this.root.querySelector('.price__regular .price-item--regular'); if (price) price.textContent = variant.price;
      }
      this.querySelectorAll('[data-d96-size]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.d96Size === this.dataset.size)));
      this.querySelectorAll('[data-d96-finish]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.d96Finish === this.dataset.finish)));
      this.update();
    }
    update() {
      const size = this.dataset.size || '18', finish = this.dataset.finish || '';
      const hasFinish = !!this.dataset.finish;
      const textHeightScale = Number(this.dataset.textHeightScale) || 1;
      const animal = this.querySelector('input[name="properties[Animal]"]:checked')?.value;
      const shape = this.data[animal]?.[size];
      const value = this.input.value.trim();
      this.svg.removeAttribute('hidden'); this.querySelector('[data-d96-empty]').hidden = true;
      const blankBar = this.querySelector('[data-d96-empty-bar]');
      blankBar.style.display = shape ? 'none' : '';
      this.querySelector('[data-d96-base]').style.display = shape ? '' : 'none';
      if (!shape) {
        const width = Number(size), height = width * .21 + 1;
        this.svg.setAttribute('viewBox', '0 0 ' + width + ' ' + height);
        const centerY = height - .5;
        const hole = x => 'M ' + (x + .125) + ' ' + centerY + ' a .125 .125 0 1 0 -.25 0 a .125 .125 0 1 0 .25 0 Z';
        blankBar.setAttribute('d', 'M 0 ' + (height - 1) + ' H ' + width + ' V ' + height + ' H 0 Z ' + hole(.5) + ' ' + hole(width - .5));
        this.text.replaceChildren();
        this.querySelector('[data-d96-caption]').textContent = size + '″ overall width · 1″ bottom bar';
        this.querySelector('.rr-d96__preview').setAttribute('aria-label', 'Blank one-inch bar, ' + size + ' inches wide');
      }
      let error = '';
      const glyphs = [], metrics = this.font.glyphs;
      let cursor = 0, inkMin = Infinity, inkMax = -Infinity;
      const displayValue = value;
      for (const char of displayValue) {
        const glyph = metrics[char];
        if (!glyph) { error = 'For punctuation or symbols, request a custom layout review.'; break; }
        if (char !== ' ') { glyphs.push({char,glyph,cursor}); inkMin = Math.min(inkMin,cursor+glyph.xMin); inkMax = Math.max(inkMax,cursor+glyph.xMax); }
        cursor += glyph.advance;
      }
      const supportedText = !error;
      let scale = 0, needsLargerSize = false;
      if (shape && value && supportedText) {
        scale = Math.min(this.font.welcome18Scale * shape.width / 18, shape.textWidth / (inkMax - inkMin));
        if (scale < this.font.minimumScale) {
          needsLargerSize = true;
          const fittingSize = [18, 24, 30, 36].find(width => width > Number(size) && this.data[animal]?.[String(width)]?.textWidth / (inkMax - inkMin) >= this.font.minimumScale);
          error = 'Preview only: this wording is too small at ' + size + '″. ' + (fittingSize ? 'Choose ' + fittingSize + '″ or larger, shorten your text, or request a custom layout review.' : 'Shorten your text or request a custom layout review.');
        }
      }
      this.querySelector('[data-d96-fit-message]').textContent = error;
      this.input.setCustomValidity(error || (value ? '' : 'Enter your custom text.'));
      if (shape) {
        const width = shape.width, height = shape.height;
        this.svg.setAttribute('viewBox','0 0 '+width+' '+height);
        const mask = this.querySelector('[data-d96-mask]'); mask.setAttribute('href',shape.url); mask.setAttribute('width',width); mask.setAttribute('height',height); mask.parentElement.setAttribute('width',width); mask.parentElement.setAttribute('height',height);
        const base = this.querySelector('[data-d96-base]'); base.setAttribute('width',width); base.setAttribute('height',height);
        const colors = {'Matte Black':['#111','#111','#111'],'Black Wrinkle':['#111','#333','#111'],'Copper Vein':['#2c1710','#a95b34','#25140f'],'Gold Vein':['#33220d','#c39a43','#211709'],'Silver Vein':['#252525','#b9b9b9','#3b3b3b'],'Rust Patina':['#5a2517','#bd6c36','#6d2d1b'],'Heat Treatment':['#765029','#6b7787','#9b6635'],'Oil Rubbed Bronze':['#17120d','#5a3c21','#17120d']}[finish] || ['#111','#111','#111'];
        this.querySelectorAll('[data-d96-stop]').forEach((stop,index) => stop.setAttribute('stop-color',colors[index]));
        this.text.replaceChildren();
        if (value && supportedText) {
          const start = shape.textX + (shape.textWidth - (inkMax - inkMin)*scale)/2 - inkMin*scale;
          glyphs.forEach(({char,glyph,cursor}) => {
            const letter = document.createElementNS('http://www.w3.org/2000/svg','text');
            letter.textContent = char; letter.setAttribute('x',start+cursor*scale); letter.setAttribute('y',glyph.yMin*scale); letter.setAttribute('transform','translate(0 '+(height-shape.textBottom)+') scale(1 '+textHeightScale+')'); letter.setAttribute('font-size',scale*this.font.unitsPerEm); this.text.append(letter);
          });
        }
        this.text.setAttribute('opacity','1');
        this.querySelector('[data-d96-caption]').textContent = (animal === 'Buck' ? 'Deer (Buck)' : animal)+' · '+size+'″ overall width · 1″ bottom bar'+(finish ? ' · '+finish : '');
        this.querySelector('.rr-d96__preview').setAttribute('aria-label',animal+', '+(value || 'your custom text')+', '+size+' inches wide, '+finish);
      }
      const valid = !!shape && !!value && !error && hasFinish && !!this.variant?.available;
      this.dataset.valid = String(valid); this.dataset.textFits = String(!!value && !error); this.dataset.fontScale = String(scale); this.dataset.previewOnly = String(needsLargerSize);
      this.querySelector('[data-d96-add]').disabled = !valid;
      this.querySelector('[data-d96-message]').textContent = !animal ? 'Choose your animal to continue.' : !value ? 'Enter your custom text to continue.' : error || (!hasFinish ? 'Choose your finish to continue.' : !this.variant?.available ? 'This selection is currently unavailable.' : 'Ready to add to cart.');
    }
  });
}


